import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]
  static values = {
    minItems: { type: Number, default: 0 },
    minItemsMessage: { type: String, default: "You must have at least %{count} item(s)" }
  }

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML('beforeend', content)
    this.updateRemoveButtons()
  }

  remove(event) {
    event.preventDefault()

    // Check if we have minimum items requirement
    const visibleItems = this.getVisibleItems()
    if (this.minItemsValue > 0 && visibleItems.length <= this.minItemsValue) {
      alert(this.minItemsMessageValue.replace('%{count}', this.minItemsValue))
      return
    }

    const wrapper = event.target.closest('.nested-fields')

    // If the item is persisted (has an ID), mark it for destruction
    const destroyInput = wrapper.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = '1'
      wrapper.style.display = 'none'
      
      // Disable required validation on hidden fields to prevent HTML5 validation errors
      wrapper.querySelectorAll('[required]').forEach(field => {
        field.removeAttribute('required')
      })
    } else {
      // If it's a new record, just remove it from the DOM
      wrapper.remove()
    }

    this.updateRemoveButtons()
  }

  connect() {
    this.updateRemoveButtons()
  }

  getVisibleItems() {
    const allItems = this.containerTarget.querySelectorAll('.nested-fields')
    return Array.from(allItems).filter(item => {
      const destroyInput = item.querySelector('input[name*="_destroy"]')
      return item.style.display !== 'none' && (!destroyInput || destroyInput.value !== '1')
    })
  }

  updateRemoveButtons() {
    if (this.minItemsValue === 0) return

    const visibleItems = this.getVisibleItems()
    const removeButtons = this.containerTarget.querySelectorAll('button[data-action*="nested-form#remove"]')

    removeButtons.forEach(button => {
      const wrapper = button.closest('.nested-fields')
      const isVisible = visibleItems.includes(wrapper)

      if (isVisible && visibleItems.length <= this.minItemsValue) {
        button.disabled = true
        button.classList.add('opacity-50', 'cursor-not-allowed')
        button.title = this.minItemsMessageValue.replace('%{count}', this.minItemsValue)
      } else {
        button.disabled = false
        button.classList.remove('opacity-50', 'cursor-not-allowed')
        button.title = ''
      }
    })
  }
}
